import {DocumentationTemplateFieldDto} from 'app/_models/model/documentationTemplateFieldDto';
import {ITemplateField} from '../_interface/itemplate-field';
import {OLD_ARRAY_INDEX_DELIMITER, BODY_ARRAY_MARKER} from 'shared/magic';
import {DocumentationTemplateFieldBodyItem} from 'app/_models/model/documentationTemplateFieldBodyItem';
import {unflatten} from 'flat';
import {stringToPrimitive} from './stringToPrimitive.fn';

export const replaceOldDelimiter = (str: string) => str.replace(new RegExp(OLD_ARRAY_INDEX_DELIMITER, 'g'), '.');
const checkOldDelimiterCorrectKey = (str: string) => str.match(new RegExp(OLD_ARRAY_INDEX_DELIMITER + '\\D', 'g'));
export const convertTemplateFieldsExp = (kv: DocumentationTemplateFieldDto[]): ITemplateField[] => {
	const parseBody = (body: DocumentationTemplateFieldBodyItem[]) => {
		try {
			const newBody = body
				.filter(({key}) => key !== BODY_ARRAY_MARKER)
				.map(({key, value}) => {
					// tslint:disable-next-line:no-console
					if (checkOldDelimiterCorrectKey(key)) console.error('Warning - some legacy keys present, if template is broken contact support', key);
					return {key: replaceOldDelimiter(key), value};
				});

			const flatObject = newBody
				.reduce((acc, {key, value}) => {
					return {...acc, ...{[key]: stringToPrimitive(value)}};
				}, {});
			return unflatten(flatObject);
		} catch (e) {
			// tslint:disable-next-line:no-console
			console.error(e);
		}
	};
	return kv.map(item => {
		return {...item, body: parseBody(item.body)} as ITemplateField;
	});
};

